import { Box, Flex, Icon, Link, Text } from '@chakra-ui/react';
import { useRouter } from 'next/router';
import { HiArrowLeft } from 'react-icons/hi';

import { Project } from '.';

interface NameProps {
  project: Project;
}

const categoryLabel: Record<string, string> = {
  web: 'Web',
  mobile: 'Mobile',
  api: 'API',
  other: 'Software',
};

export function Name({ project }: NameProps) {
  const { back } = useRouter();

  return (
    <Box mb="40px">
      <Link
        as="button"
        onClick={back}
        display="inline-flex"
        alignItems="center"
        gap="8px"
        fontFamily="mono"
        fontSize="12px"
        letterSpacing="0.12em"
        textTransform="uppercase"
        color="text.muted"
        mb="32px"
        _hover={{ color: 'accent.500', textDecoration: 'none' }}
        transition="color 0.2s ease"
      >
        <Icon as={HiArrowLeft} /> Voltar
      </Link>

      <Flex
        align="center"
        gap="14px"
        mb="16px"
        fontFamily="mono"
        fontSize="11px"
        letterSpacing="0.16em"
        textTransform="uppercase"
        color="text.faint"
      >
        <Text>{categoryLabel[project.category] || project.category}</Text>
        <Box flex="1" h="1px" bg="line.subtle" maxW="120px" />
      </Flex>

      <Box
        as="h1"
        fontFamily="display"
        fontWeight="400"
        fontSize={{ base: '48px', md: '88px' }}
        lineHeight="0.95"
        letterSpacing="-0.03em"
        color="text.primary"
      >
        {project.name}
        <Box as="span" color="accent.500">
          .
        </Box>
      </Box>
    </Box>
  );
}
